import { useMemo } from "react";
import AccessListSection from "admin/components/AccessListSection";
import { AccessDefinition } from "admin/types/interfaces/access";
import { TablesIcon } from "~/assets/icons";

const SchemaAccessList = ({ data }: { data: AccessDefinition[] }) => {
  const schemaMap = useMemo(() => {
    if (data.length) {
      return data.reduce<Record<string, { label: string; access: AccessDefinition["access"] }[]>>(
        (acc, { access, component, tagged_component }) => {
          const [schema, table] = (tagged_component ?? component)!.definition.split(".");

          acc[schema] = acc[schema] ?? [];

          // Find existing entry in the accumulator
          const existingEntry = acc[schema].find((entry) => entry.label === table);

          if (existingEntry) {
            // If existing entry has "read" access and current access is "write", upgrade it
            if (existingEntry.access === "read" && access === "write") {
              existingEntry.access = "write";
            }
          } else {
            // Otherwise, add the new entry
            acc[schema].push({ label: table, access });
          }

          return acc;
        },
        {}
      );
    }

    return null;
  }, [data]);

  if (!schemaMap) {
    return null;
  }

  return (
    <div className="space-y-1">
      {Object.entries(schemaMap).map(([schema, tableList]) => (
        <AccessListSection key={schema} icon={TablesIcon} title={schema} items={tableList} />
      ))}
    </div>
  );
};

export default SchemaAccessList;
